import React from 'react';
import { useLanguage } from './LanguageContext';

const SideNav = ({ isOpen, onClose, onOpenPrivacy, onOpenImpressum }) => {
  const { t } = useLanguage();

  const getNavWidth = () => {
    const width = window.innerWidth;
    if (width <= 500) return '80%';
    if (width <= 800) return '66.67%';
    return '50%';
  };

  const handleNavClick = (id) => {
    onClose();
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 60; // Adjust this value based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const handleModalLink = (action) => {
    onClose();
    action();
  };

  const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    opacity: isOpen ? 1 : 0,
    visibility: isOpen ? 'visible' : 'hidden',
    transition: 'opacity 0.3s ease, visibility 0.3s ease',
    zIndex: 1000
  };

  const navStyle = {
    position: 'fixed',
    top: 0,
    right: 0,
    width: getNavWidth(),
    height: '100%',
    backgroundColor: '#B9ABA2',
    transform: isOpen ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.3s ease',
    zIndex: 1001,
    display: 'flex',
    flexDirection: 'column',
    padding: '80px 40px 40px'
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '30px',
    right: '30px',
    background: 'none',
    border: 'none',
    fontSize: '32px',
    color: 'white',
    cursor: 'pointer',
    padding: '10px'
  };

  const navLinksStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '30px'
  };

  const linkStyle = {
    color: 'white',
    textDecoration: 'none',
    fontSize: '24px',
    fontFamily: 'Sora, sans-serif',
    fontWeight: '300',
    cursor: 'pointer'
  };

  const jobsLinkStyle = {
    ...linkStyle,
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  };

  const jobsBadgeStyle = {
    backgroundColor: '#cec800',
    color: 'white',
    borderRadius: '50%',
    width: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '500'
  };

  const footerLinksStyle = {
    marginTop: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  };

  const footerLinkStyle = {
    color: 'white',
    textDecoration: 'none',
    fontSize: '14px',
    fontFamily: '-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif',
    opacity: 0.8,
    cursor: 'pointer'
  };

  return (
    <>
      <div style={overlayStyle} onClick={onClose} />
      <nav style={navStyle}>
        <button style={closeButtonStyle} onClick={onClose}>×</button>
        <div style={navLinksStyle}>
          <div style={linkStyle} onClick={() => handleNavClick('willkommen')}>{t('navWelcome')}</div>
          <div style={linkStyle} onClick={() => handleNavClick('leistungen')}>{t('navServices')}</div>
          <div style={linkStyle} onClick={() => handleNavClick('ruecken')}>{t('navBack')}</div>
          <div style={linkStyle} onClick={() => handleNavClick('ueber-mich')}>{t('navAbout')}</div>
          <div style={linkStyle} onClick={() => handleNavClick('team')}>{t('navTeam')}</div>
          {/* <div style={jobsLinkStyle} onClick={() => handleNavClick('jobs')}>
            Jobs
            <span style={jobsBadgeStyle}>1</span>
          </div> */}
          <div style={linkStyle} onClick={() => handleNavClick('praxis')}>{t('navPractice')}</div>
          <div style={linkStyle} onClick={() => handleNavClick('kontakt')}>{t('navContact')}</div>
        </div>
        <div style={footerLinksStyle}>
          <div style={footerLinkStyle} onClick={() => handleModalLink(onOpenImpressum)}>{t('impressum')}</div>
          <div style={footerLinkStyle} onClick={() => handleModalLink(onOpenPrivacy)}>{t('privacy')}</div>
        </div>
      </nav>
    </>
  );
};

export default SideNav; 